module.exports = __webpack_public_path__ + "static/media/instagram-footer-dark.0b6097cb.svg";